module.exports = __webpack_public_path__ + "f7de6948969e5b50d55403e97ee407d4.png";